
import { Component, Vue } from 'vue-property-decorator'
import {
  AllMenu,
  GetMenu,
  SaveMenuFuns,
  GetMenuFuns,
  SaveMenu,
  DelMenu
} from '@/api/admin/permission'
import menuicons from '@/common/menuicons'
@Component
export default class adminMenu extends Vue {
  name = 'userAdmin_adminMenu'
  select = {
    menu_list: [],
    icon_List: menuicons
  }
  tree = {
    data: []
  }
  form = {
    ref: 'form',
    funcs: '',
    data: { menu_id: 0, status: 1, icon: '', ispage: 1, pid: 0, name: '' },
    rules: {
      name: [
        {
          required: true,
          trigger: 'blur',
          validator: (this as any).simpleVerify('请输入菜单名')
        }
      ],
      url: [{ required: true, message: '请输入对应路由名', trigger: 'blur' }],
      classname: [
        { required: true, message: '请输入对应菜单标识', trigger: 'blur' }
      ],
      pid: [
        {
          required: true,
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (this.form.data.menu_id == (this.tree.data[0] as any).menu_id) {
              callback()
            } else if (!value) {
              callback('请选择上级菜单')
            } else {
              callback()
            }
          }
        }
      ]
    }
  }
  icon = {
    show: false,
    iconSearch: ''
  }
  allMenu() {
    AllMenu({}).then(res => {
      let dataList: any = res['_param'].list
      let data: any = dataList
      let arr: any = []
      let arrList: any = []
      data.map(item => {
        item.children = item.children || []
        item.children.sort((v1, v2) => {
          return v1.sorts - v2.sorts
        })
        item.children.map(item2 => {
          item2.children = item2.children || []
        })
      })
      let data1 = (this as any).copyData(dataList || [])

      data1.map((item, index) => {
        let list_name = item.title
        arr.push({
          menu_id: item.menu_id,
          name: item.title,
          list_name: list_name
        })
        item.children.map((item1, index) => {
          let list_name1
          if ((item1.children.length = index + 1)) {
            list_name1 = `　　└╌ ${item1.title}`
          } else {
            list_name1 = `　　├╌ ${item1.title}`
          }
          arr.push({
            menu_id: item1.menu_id,
            name: item1.title,
            list_name: list_name1
          })
        })
      })
      this.select.menu_list = arr
      // 树层级内容
      let tree_data = (this as any).copyData(dataList || [])
      tree_data[0].children.map(item => {
        item.expand = true
        item.children = item.children.filter(v => v)
      })
      this.tree.data = (this as any).copyData(tree_data)
      this.form.data.pid = tree_data[0].menu_id
    })
  }
  //提交修改，添加菜单
  Update() {
    let FormData: any = this.$refs[this.form.ref]
    FormData.validate(valid => {
      if (valid) {
        this.saveMenu()
      }
    })
    //
  }
  currentIsTop() {
    let item = (this.tree.data as any)[0] || {}
    return this.form.data.menu_id == item.menu_id
  }
  // 保存菜单
  saveMenu() {
    let params = { ...this.form.data }
    params.pid = params.pid || 0
    SaveMenu(params).then(res => {
      this.$Message.success('操作成功')
      this.allMenu()
      this.saveMenuFuns(res._param.menu_id)
    })
  }
  //删除菜单
  Delete() {
    this.$Modal.confirm({
      title: '提示',
      content: '删除此菜单将导致该菜单及其子菜单不可用，是否确定删除？',
      onOk: () => {
        let param = {
          menu_id: [this.form.data.menu_id]
        }
        DelMenu(param).then(res => {
          this.$Message.success('删除成功')
          this.allMenu()
          ;(this.$refs[this.form.ref] as any).resetFields()
        })
      }
    })
  }
  Reset() {
    this.form.data = {
      menu_id: 0,
      status: 1,
      icon: '',
      ispage: 1,
      pid: (this.tree.data[0] as any).menu_id,
      name: ''
    }
    ;(this.$refs[this.form.ref] as any).resetFields()
  }
  SelectTreeItem(data) {
    ;(this.$refs[this.form.ref] as any).resetFields()
    let item: any = data[0] || {}
    this.form.data = { ...item }
    this.form.data.name = item.title || ''
    delete this.form.data['selected']
    delete this.form.data['children']
    delete this.form.data['nodeKey']
    delete this.form.data['expand']
    delete this.form.data['title']
    if (item.menu_id !== undefined) {
      this.getMenuFuns(item.menu_id)
    }
  }
  // 确定图标选择
  selecticon(item) {
    // 确定图标选择
    this.form.data.icon = item
    this.icon.show = false
  }
  openicons() {
    this.icon.show = true
  }
  saveMenuFuns(id) {
    let params = {
      menu_id: id,
      funs: this.form.funcs ? this.form.funcs.split(',') : []
    }
    SaveMenuFuns(params).then(res => {})
  }
  getMenuFuns(id) {
    let params = { menu_id: id }
    GetMenuFuns(params).then(res => {
      let data = res['_param'].funs || []
      this.form.funcs = data.join(',')
    })
  }
  created() {
    this.allMenu()
  }
}
